import { render, staticRenderFns } from "./RedirectOldUrlCheckbox.vue?vue&type=template&id=361393a5"
import script from "./RedirectOldUrlCheckbox.vue?vue&type=script&lang=js"
export * from "./RedirectOldUrlCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports